<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <div class="desc">
            {{ $t($parent.footerCopyright) }}
          </div>
        </div>
        <div class="center">
          <a href="index.html" class="logo">
            <img src="./../image/logo.svg" class="img" />
          </a>
        </div>
        <div class="right">
          <div class="desc">
            {{ $t($parent.footerRequisites) }}
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-section">
      <div class="wrapper">
        <div class="left">
          <div class="list">
            <div class="item">
              <img src="./../image/visa.png" class="img" />
            </div>
            <div class="item">
              <img src="./../image/mastercard.svg" class="img" />
            </div>

            <!--            <div class="item">-->
            <!--              <img src="./../image/3ds.svg" class="img" />-->
            <!--            </div>-->

            <div class="item">
              <img src="./../image/apay.svg" class="img" />
            </div>

            <div class="item">
              <img src="./../image/gpay.png" class="img" />
            </div>
          </div>
        </div>
        <div class="right">
          <ul class="nav">
            <template v-for="item in $parent.textPageList">
              <li class="nav__item desc small" :key="item.id" v-if="item.title">
                <a @click="$parent.goToPage(item.id)">
                  <b>{{ $t(item.title) }}</b>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="trademark-disclaimer">
      {{
        $t(
          "All game skins, trademarks, and related names are the property of their respective owners. This site is not affiliated with any of the game developers or publishers."
        )
      }}
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {
      paymentMethodsIsVisible: false,
      email: "",
    };
  },
  methods: {
    submit() {
      let data = {
        email: this.email,
      };
      this.$emit("submitSubscribtion", data);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.trademark-disclaimer {
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
  padding-bottom: 15px;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 768px) {
    margin-top: 10px;
    font-size: 10px;
  }
}
</style>
